"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupPermissionsSection = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const core_ui_1 = require("@sierralabs/core-ui");
const user_ui_1 = require("@sierralabs/user-ui");
const GroupPermissionsSection = props => {
    var _a, _b;
    const { shape, onChange } = props;
    const groupPermissions = ((_b = (_a = shape.data) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.groupPermissions) || [];
    return (react_1.default.createElement(core_ui_1.ConfigCard, null,
        react_1.default.createElement(core_ui_1.ConfigHeader, null, "Team Permissions"),
        react_1.default.createElement(core_ui_1.ConfigContent, null,
            react_1.default.createElement(core_1.FormControl, { className: 'form-control' },
                react_1.default.createElement(user_ui_1.GroupPicker, { multiple: true, onChange: onChange, value: groupPermissions }),
                react_1.default.createElement(core_1.FormHelperText, { className: 'helper-text' }, "If there are selected Teams, only they can edit the fields selected below.")))));
};
exports.GroupPermissionsSection = GroupPermissionsSection;
exports.default = exports.GroupPermissionsSection;
//# sourceMappingURL=GroupPermissionsSection.js.map